import { withState } from 'recompose';

export default withState('companyName', 'updateCompanyName', '');
